(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener("submit", function (event) {
  var form = event.target.closest("[data-newsletter-form]");
  if (!form) return;
  var trap = form.querySelector("[data-newsletter-trap]");
  if (trap && trap.value) {
    event.preventDefault();
  }
});

  } catch(e) { console.error(e); }
})();
})();
